import React from "react";
import { TabProps } from "../../../../SourceModal.types";
import BaseOverview from "./BaseOverview";

const RedirectOverview: React.FC<TabProps> = ({ source, language }) => {
    const eventUrls = source?.event_urls;

    return (
        <BaseOverview language={language}>
            <div>
                <h1 className="mb-3">Link Event</h1>
                {eventUrls && Object.keys(eventUrls).length > 0 && (
                    <div className="bearer-token-area">
                        <div className="bearer-token-blockquote">
                            {Object.keys(eventUrls).map((item, index) => (
                                <div
                                    key={item}
                                    className="bearer-token-blockquote-item"
                                >
                                    <span className="domain">{item}: </span>
                                    <a
                                        href={
                                            Object.values(eventUrls)[
                                                index
                                            ] as string
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="document"
                                    >
                                        {
                                            Object.values(eventUrls)[
                                                index
                                            ] as string
                                        }
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                <p>
                    {language?.tracker_detail?.overview?.redirect_msg ??
                        "Link Event is a type of source that allows you to send events to Meta, TikTok, Snap, and many other advertising platforms in just a few minutes without any code implementation on your website."}
                </p>
            </div>
        </BaseOverview>
    );
};

export default RedirectOverview;


